import { Box, Skeleton, styled } from "@mui/material";
import { GridLoadingOverlayProps } from "@mui/x-data-grid-pro";
import React from "react";
import { TableType } from "../serverSide/types";

interface BaseSkeletonProps {
  width?: string | number;
  key?: React.Key;
}

export const BaseSkeleton = ({ ...rest }: BaseSkeletonProps) => {
  const skeletonStyle = {
    mb: 2,
    borderRadius: "4px",
    bgcolor: "rgba(0, 0, 0, 0.04)",
  };

  return <Skeleton variant="rectangular" height={40} animation="wave" sx={skeletonStyle} {...rest} />;
};

export default BaseSkeleton;
